import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { notificationTopic } from '@bd/shared/utils';
import { LoadingNotificationService } from 'chronos-shared';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { EditSetupParameterComponent } from './components/edit-setup-parameter.component';
import { SetupParameterDsService } from '@bd/core/data-services/setup-parameter-ds/setup-parameter-ds.service';
import { SetupParameterService } from '@bd/core/global-state/setup-parameter/setup-parameter.service';
import { SetupParameterQuery } from '@bd/core/global-state/setup-parameter/setup-parameter.query';

@Component({
  selector: 'app-setup-parameter',
  templateUrl: './setup-parameter.component.html',
  styleUrls: ['./setup-parameter.component.scss']
})
export class SetupParameterComponent implements OnInit, OnDestroy {

  @ViewChild(EditSetupParameterComponent) editSetupParameterComponent!: EditSetupParameterComponent;
  public enableSetupParameterSubject = new BehaviorSubject<boolean>(true);
  public enableSetupParameter$: Observable<boolean> = this.enableSetupParameterSubject.asObservable();
  public isFormValid: boolean = true;
  public loading: boolean;
  public externalSetupParameterKindId: string;
  public readonly LOADING_TOPIC_SAVESETUPPARAMETER = notificationTopic.saveSetupParameterDetails;
 
  private subscriptions = new Subscription();
 
  constructor(
    public setupParameterQuery: SetupParameterQuery,
    private setupParameterDsService: SetupParameterDsService,
    private setupParameterService: SetupParameterService
  ) {}
 
  public ngOnInit(): void {
   this.subscriptions.add(this.getSetupParameterData());
  }
 
  public updateEditedSetupParameters() {
    this.subscriptions.add(this.getSetupParameterData());
  }
 
  public resetFilters(): void {
     this.externalSetupParameterKindId = null;
 
     this.getSetupParameterData();
  }
 
  public reloadData(): void {
     // cancel reloads the data
     this.cancel();
  }
 
   public onFilterChange(): void {
     this.getSetupParameterData();
   }
 
   public ngOnDestroy(): void {
     this.subscriptions.unsubscribe();
   }
 
   private getSetupParameterData(): void {
    const trimmedQuery = this.externalSetupParameterKindId?.trim() || '';

     this.setupParameterDsService.getSetupParameterKinds(null, trimmedQuery, null, null).subscribe((parameterList) => {
      this.setupParameterService.updateSetupParameter(parameterList);
     });
   }
 
   public save() {
     LoadingNotificationService.publish(this.LOADING_TOPIC_SAVESETUPPARAMETER, true);
    //  this.setupParameterDsService.onSaveAll().subscribe(
    //    () => this.finalizeSave(true),
    //    () => this.finalizeSave(false)
    //  );
   }
 
   private finalizeSave(success: boolean): void {
     this.enableSetupParameterSubject.next(true);
     if (success) {
       LoadingNotificationService.publish(this.LOADING_TOPIC_SAVESETUPPARAMETER, false);
     }
   }
 
   public editAll() {
     this.enableSetupParameterSubject.next(false);
     this.editSetupParameterComponent.onEditAll();
   }
 
   public cancel(): void {
     this.enableSetupParameterSubject.next(true);
     this.getSetupParameterData();
     this.editSetupParameterComponent.onCancelEdit();
   }
 
   public onFormValidityChange(valid: boolean) {
     this.isFormValid = valid;
   }

}
